<template>
  <div id="app">
    <router-view></router-view>
    <Toast :text="textMsg" id="toast" ref="toast"/>
    <FullLoading id="fullLoading" v-show="isLoading"/>
  </div>
</template>

<script type="text/ecmascript-6">
  import FullLoading from 'base/full-loading/full-loading';
  import Toast from 'base/toast/toast';
  import { mapMutations } from 'vuex';
  import * as types from './store/mutation-types';
  //  import comm from './assets/css/comm.css'//初始化css 
    // import resize from './assets/js/resize';//自适应屏幕  
  export default {
    name: 'app',
    data() {
      return {
        textMsg: '',
        coinData: {},
        isLoading: false,
        interTime: null
      }
    },
    created() {},
    methods: {
      ...mapMutations({
        ...types
      })
    },
    components: {
      Toast,
      FullLoading
    },
    beforeDestroy() {}
  };
</script>
<style lang="scss">
@import './stylus/index.css';
  #app {
    // font-size: 0 !important;
    overflow-x: hidden;
    /*background-color: #fff;*/
    -webkit-overflow-scrolling: auto; // 阻止元素滑动回弹
    // -webkit-overflow-scrolling: touch;
    width: 100%;
    height: 100%;
    background: #fff;
    .slide-enter-active, .slide-leave-active {
      transition: all 0.3s;
    }

    .slide-enter, .slide-leave-to {
      transform: translate3d(-100%, 0, 50%);
    }
  }
  .all-content{
    width: 100%;
    margin: 0 auto;
  }

  .loading-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .loading-wrapper {
      position: absolute;
      top: 50%;
      width: 100%;
      transform: translate3d(0, -50%, 0);
    }
  }

  .hidden {
    display: none !important;
  }

  .show {
    display: block !important;
  }

  .no-data {
    width: 100%;
    padding: 1.6rem 0 1.2rem;
    text-align: center;
    img {
      vertical-align: bottom;
      width: 2rem;
    }
    p {
      font-size: 15px;
      color: #999;
      margin-top: 15px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/App.vue